export * from "./ViewFooter";
